export function AppFooter() {
  const year = new Date().getFullYear();
  return (
    <footer className="app-footer">
      <span>{`Version ${process.env.REACT_APP_VERSION}`}</span>
      <span className="app-footer-sep" aria-hidden="true">
        ·
      </span>
      <span>© {year} amlabs.org</span>
    </footer>
  );
}
